module.exports = __webpack_public_path__ + "static/media/ic-switch-acc.b9d86732.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-switch-acc.svg
// module id = 674
// module chunks = 14